import { atom } from 'recoil';

export default atom({
  key: 'isReportModalOpen',
  default: false,
});
